const FounderAlt = () => {
  return (
    <section className="py-32 px-4 bg-secondary">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded">
                <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">Founder</span>
              </div>
              <h2 className="text-6xl md:text-7xl font-black leading-none tracking-tight text-foreground">
                ARUN MOHAN
              </h2>
              <p className="text-2xl font-bold text-accent">
                Investor
              </p>
            </div>

            <p className="text-xl text-foreground leading-relaxed font-medium">
              AMX Ventures was born from my journey of building, scaling, and exiting multiple 
              ventures in the Middle East. I have learned that success comes from <span className="font-bold text-primary">connecting the right people with the right opportunities</span>—whether that is founders with capital and channels, partners with innovative solutions, or customers with transformative products.
            </p>

            <div className="space-y-4 pt-8">
              <div className="p-6 bg-background border-l-4 border-accent hover:shadow-lg transition-shadow">
                <p className="font-bold text-lg text-foreground">Founded & Exited Adfolks LLC</p>
                <p className="text-sm text-muted-foreground mt-1">Part of <span className="text-foreground font-semibold">Zain Telecom</span></p>
              </div>
              
              <div className="p-6 bg-background border-l-4 border-primary hover:shadow-lg transition-shadow">
                <p className="font-bold text-lg text-foreground">Founded & Exited Appsintegra</p>
                <p className="text-sm text-muted-foreground mt-1"><span className="text-foreground font-semibold">AWS Specialized</span> GTM Engine</p>
              </div>
              
              <div className="p-6 bg-background border-l-4 border-accent hover:shadow-lg transition-shadow">
                <p className="font-bold text-lg text-foreground">Investor & GTM Advisor</p>
                <p className="text-sm text-muted-foreground mt-1">
                  <span className="text-foreground font-semibold">Nimo Infinity</span>, 
                  <span className="text-foreground font-semibold"> Onepane.ai</span>,
                  <span className="text-foreground font-semibold"> Actualize.pro</span>,
                  <span className="text-foreground font-semibold"> RAIGen AI</span>
                </p>
              </div>
              
              <div className="p-6 bg-background border-l-4 border-primary hover:shadow-lg transition-shadow">
                <p className="font-bold text-lg text-foreground">Ecosystem Architect</p>
                <p className="text-sm text-muted-foreground mt-1">Connecting <span className="text-foreground font-semibold">founders, partners, and customers</span> for mutual growth</p>
              </div>
            </div>
          </div>

          {/* Right - Stats Cards */}
          <div className="space-y-6">
            <div className="p-10 bg-primary text-primary-foreground">
              <div className="text-8xl font-black mb-4 text-accent">10+</div>
              <p className="text-lg font-bold tracking-wider">
                YEARS BUILDING VENTURES IN THE MIDDLE EAST
              </p>
            </div>

            <div className="p-10 bg-accent text-accent-foreground">
              <div className="text-8xl font-black mb-4">90%</div>
              <p className="text-lg font-bold tracking-wider">
                CAC REDUCTION THROUGH ECOSYSTEM GTM
              </p>
            </div>

            <div className="p-10 bg-background border-4 border-accent">
              <div className="text-8xl font-black mb-4 text-accent">6+</div>
              <p className="text-lg font-bold tracking-wider text-foreground">
                PORTFOLIO COMPANIES SCALING VIA CHANNELS
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderAlt;
